import type { ReactElement } from 'react';
import { Badge } from '@/components/ui/badge';
import type { MCPType } from '@kirin/api-client/contracts/mcp';
import { Globe, HardDrive } from 'lucide-react';
import { typeLabels } from './labels';

/**
 * Badge variant mapping for MCP types
 */
const typeBadgeVariants: Record<
  MCPType,
  'default' | 'secondary' | 'outline' | 'destructive'
> = {
  local: 'secondary',
  remote: 'outline',
};

interface MCPTypeBadgeProps {
  type: string;
}

/**
 * Badge component for displaying MCP type (Local/Remote) with icon
 */
export function MCPTypeBadge({ type }: MCPTypeBadgeProps): ReactElement {
  const Icon = type === 'local' ? HardDrive : Globe;

  return (
    <Badge
      variant={typeBadgeVariants[type as MCPType] || 'outline'}
      className="gap-1"
    >
      <Icon className="h-3 w-3" />
      {typeLabels[type as MCPType] || type}
    </Badge>
  );
}
